/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Hub_Credits_BodyInputs */

const en_legal_hub_credits_body = /** @type {(inputs: Legal_Hub_Credits_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscle illustrations adapted from [Human Anatomy Component System](https://www.figma.com/community/file/1320468164820924031) by Ryan Graves, licensed under [CC BY 4.0](https://creativecommons.org/licenses/by/4.0/). We simplified the drawings and added the lower back.`)
};

const pl_legal_hub_credits_body = /** @type {(inputs: Legal_Hub_Credits_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilustracje mięśni na podstawie [Human Anatomy Component System](https://www.figma.com/community/file/1320468164820924031) autorstwa Ryana Gravesa, na licencji [CC BY 4.0](https://creativecommons.org/licenses/by/4.0/). Uprościliśmy rysunki i dorysowaliśmy dolną część pleców.`)
};

/**
* | output |
* | --- |
* | "Muscle illustrations adapted from [Human Anatomy Component System](https://www.figma.com/community/file/1320468164820924031) by Ryan Graves, licensed under [..." |
*
* @param {Legal_Hub_Credits_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_hub_credits_body = /** @type {((inputs?: Legal_Hub_Credits_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Hub_Credits_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_hub_credits_body(inputs)
	return en_legal_hub_credits_body(inputs)
});